import Back from "./Back";
import Cart from "./Cart";
import Contact from "./Contact";
import Logo from "./Logo";


export default function Aside(){

    return (
    
        <aside className="apply-aside">

            <div className="apply-aside-top">
                
                <Back />

                <Logo />

            </div>

            <Cart />

            <Contact />
            
        </aside>
    );
}